import numeral from 'numeral';
export var formatPhoneNumber = function (value) {
    if (!value)
        return "";
    var temp = value.replace(/\D/g, '');
    var result = temp && "(" + temp.substr(0, 3);
    temp.length > 3 && (result += ") " + temp.substr(3, 3), temp.length > 6 && (result += "-" + temp.substr(6, 4)));
    return result;
};
export var moneyText = function (v) {
    return numeral(v).format('$0,0.00');
};
